import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog } from 'primereact/dialog';
import PageContent from 'layouts/PageContent';
import ResultadoFormularioFilters from './ResultadoFormularioFilters';
import ResultadoFormularioList from './ResultadoFormularioList';
import ResultadoFormularioDet from './ResultadoFormularioDet';

const ResultadoFormularioScreen = () => {
  const { t } = useTranslation(['formulario']);

  const [filters, setFilters] = useState(null);
  const [idFormularioResuelto, setIdFormularioResuelto] = useState(null);

  return (
    <PageContent title={t('formulario:QuestionnaireResult')}>
      <ResultadoFormularioFilters setFilters={setFilters} />
      <div className="mt-2">
        <ResultadoFormularioList filters={filters} onViewDetail={setIdFormularioResuelto} />
      </div>

      <Dialog
        visible={idFormularioResuelto !== null}
        onHide={() => setIdFormularioResuelto(null)}
        header={t('formulario:QuestionnaireResultTitle')}
        style={{ width: '70vw' }}
        breakpoints={{ '1700px': '85vw', '1000px': '100vw' }}
        blockScroll={true}
      >
        <ResultadoFormularioDet
          IdFormularioResuelto={idFormularioResuelto}
          returnResultados={() => setIdFormularioResuelto(null)}
        />
      </Dialog>
    </PageContent>
  );
};

export default ResultadoFormularioScreen;
